// Lives under config/ so Rails can read it after the slug build deletes client/
import BADGE_TOKENS from "../../../../config/badge_tokens.json"

export const BADGE_TOKEN_NAMES = BADGE_TOKENS.map(({ name }) => name)

export default BADGE_TOKENS
